import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <section className="divine-rays relative flex min-h-[70vh] items-center overflow-hidden py-20" data-testid="payment-cancel-page">
      <div className="mx-auto max-w-xl px-4 text-center sm:px-6">
        <h1 className="font-serif text-4xl font-light text-[#1C1815]">Checkout cancelled</h1>
        <p className="mx-auto mt-4 max-w-md text-base font-light leading-relaxed text-[#4A423A]">
          No charge was made. Whenever you're ready, the piece will be waiting for you.
        </p>
        <Link to="/portfolio" className="btn-primary mt-10" data-testid="cancel-back-button">Back to Gallery</Link>
      </div>
    </section>
  );
}
